var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdrawA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12.9667,
    height: 11.8,
    viewBox: "0 0 12.9667 11.8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.98333 5.31667L9.98333 2.98333L2.98333 2.98333V9.98333C2.98333 10.6277 3.50567 11.15 4.15 11.15H8.81667C9.461 11.15 9.98333 10.6277 9.98333 9.98333V5.31667ZM9.98333 5.31667C11.272 5.31667 12.3167 4.272 12.3167 2.98333C12.3167 1.69467 11.272 0.65 9.98333 0.65H2.98333C1.69467 0.65 0.65 1.69467 0.65 2.98333C0.65 4.272 1.69467 5.31667 2.98333 5.31667",
    stroke: "#9B0000",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawA);
export default __webpack_public_path__ + "static/media/withdraw-a.4756de9cff8138e6293bd953b9b0bdab.svg";
export { ForwardRef as ReactComponent };